import { useMutation } from "react-query";

import { MUTATION_KEYS } from "../../../constants/queryKeys";
import { PlatformApi } from "../../../services/platform/PlatformApi";

export const usePlatformValidation = () => {
  const { isError, isLoading, mutateAsync, error, data } = useMutation(
    MUTATION_KEYS.platformValidation,
    async (phone: string) => {
      const platformApi = PlatformApi.init();
      return platformApi.verifyPhone(phone);
    }
  );

  return { isError, isLoading, error, data, validatePhone: mutateAsync };
};
